import React from 'react'
import styled from 'styled-components/macro'

function SpartacusSignalCell({ label, isActive, tone }) {
  const resolvedTone =
    tone ??
    (isActive === undefined ? 'muted' : isActive ? 'positive' : 'negative')

  return <SignalText $tone={resolvedTone}>{label}</SignalText>
}

const SignalText = styled.span`
  color: ${({ $tone, theme }) => {
    if ($tone === 'positive') {
      return theme.colours.lettuceGreen
    }
    if ($tone === 'warning') {
      return theme.colours.orange
    }
    if ($tone === 'negative') {
      return theme.colours.chilliRed
    }
    return theme.colours.oliveGrey
  }};
  font-weight: 600;
`

export default SpartacusSignalCell
